// extracted by mini-css-extract-plugin
module.exports = {"root":"cell_root__RkiOh","payout":"cell_payout__iDgiV"};